var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-create-layout',[_c('moduleForm',{attrs:{"dataContainer":_vm.dataContainer,"edit-mode":false,"formHeader":true,"formTitle":"Upload VOS Report"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }